import { gql } from '__generated__'

export const GetCompanyMergePreview = gql(/* GraphQL */ `
    query GetCompanyMergePreview($companyId: ID!) {
        company(id: $companyId) {
            id
            value
            notes {
                id
                title
                noteData
                createdAt
                createdByUser {
                    firstName
                    lastName
                }
            }
            documents {
                id
                documentKey
                createdAt
            }
            companyOffices {
                id
                isHeadquarters
                officeLocation {
                    value
                }
            }
            industries {
                id
                topTier
                isPrimary
                industry {
                    value
                }
            }
            sectors {
                id
                topTier
                sector {
                    value
                }
            }
            companyFunds {
                id
                name
                fundSizeMillions
                year
            }
            fundSizeBuckets {
                id
                value
            }
            recruiterContacts {
                id
                group
                contactType
                recruiter {
                    user {
                        firstName
                        lastName
                    }
                }
            }
            workExperience {
                id
                startDate
                endDate
                isCurrent
                title {
                    value
                }
            }
            rosters {
                id
                rosterName
                status
                rosterType
            }
            jobBoards {
                id
                name
                description
                startDate
            }
            clients {
                id
                isAdmin
                user {
                    firstName
                    lastName
                }
            }
            candidateReferences {
                id
                firstName
                lastName
            }
            candidateNotes {
                id
                notePreview
                createdAt
                createdByUser {
                    firstName
                    lastName
                }
            }
            groupNotes {
                id
                notePreview
                createdAt
                createdByUser {
                    firstName
                    lastName
                }
            }
        }
    }
`)

export const MergeCompanies = gql(/* GraphQL */ `
    mutation MergeCompanies($winnerId: ID!, $loserId: ID!, $liveRun: Boolean) {
        mergeCompanies(
            winnerId: $winnerId
            loserId: $loserId
            liveRun: $liveRun
        ) {
            name
            workExperience {
                id
                startDate
                endDate
                isCurrent
                title {
                    value
                }
            }
            rosters {
                id
                rosterName
                status
                rosterType
            }
            jobBoards {
                id
                name
                description
                startDate
            }
            clients {
                id
                isAdmin
                user {
                    firstName
                    lastName
                }
            }
            candidateReferences {
                id
                firstName
                lastName
            }
            candidateNotes {
                id
                notePreview
                createdAt
                createdByUser {
                    firstName
                    lastName
                }
            }
            groupNotes {
                id
                notePreview
                createdAt
                createdByUser {
                    firstName
                    lastName
                }
            }
            notes {
                id
                title
                noteData
                createdAt
                createdByUser {
                    firstName
                    lastName
                }
            }
            documents {
                id
                documentKey
                createdAt
            }
            offices {
                id
                isHeadquarters
                officeLocation {
                    value
                }
            }
            industries {
                id
                topTier
                isPrimary
                industry {
                    value
                }
            }
            sectors {
                id
                topTier
                sector {
                    value
                }
            }
            companyFunds {
                id
                name
                fundSizeMillions
                year
            }
            fundSizeBuckets {
                id
                value
            }
            recruiterContacts {
                id
                group
                contactType
                recruiter {
                    user {
                        firstName
                        lastName
                    }
                }
            }
        }
    }
`)
